/* Atelier Movement — menu, picker, sticky CTA, attribution capture, form validation. No dependencies. */
(function () {
  'use strict';
  var d = document;
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'];
  var INTEREST = { home: ['Home', 'Home'], studio: ['Studio', 'Studio'], program: ['Studio', 'Studio Program'] };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readStore(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function writeStore(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked: fields still filled from URL */ } }
  function clearStore(k) { try { sessionStorage.removeItem(k); } catch (e) { /* ignore */ } }

  /* ---- Mobile menu ---- */
  var header = d.querySelector('[data-header]');
  var menuBtn = d.querySelector('[data-menu-toggle]');
  if (header && menuBtn) {
    var setMenu = function (open) {
      header.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    menuBtn.addEventListener('click', function () { setMenu(!header.classList.contains('is-open')); });
    header.querySelectorAll('.am-nav a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-open')) { setMenu(false); menuBtn.focus(); }
    });
    d.addEventListener('click', function (e) {
      if (header.classList.contains('is-open') && !header.contains(e.target)) setMenu(false);
    });
  }

  /* ---- Ad attribution: keep campaign source across pages in this visit ---- */
  function attribution() {
    var params = new URLSearchParams(location.search);
    var fresh = {}, hasFresh = false;
    ATTR_KEYS.forEach(function (k) { var v = params.get(k); if (v) { fresh[k] = v.slice(0, 250); hasFresh = true; } });
    var saved = readStore('am_attr') || {};
    if (hasFresh) {
      saved = fresh;
      saved.landing_page = location.href.slice(0, 500);
      saved.referrer = (d.referrer || '').slice(0, 500);
    }
    if (!saved.landing_page) saved.landing_page = location.href.slice(0, 500);
    if (saved.referrer === undefined) saved.referrer = (d.referrer || '').slice(0, 500);
    writeStore('am_attr', saved);
    return saved;
  }
  var attr = attribution();
  d.querySelectorAll('[data-attr]').forEach(function (el) { el.value = attr[el.getAttribute('data-attr')] || ''; });

  /* ---- "Which model fits you" picker ---- */
  d.querySelectorAll('[data-picker]').forEach(function (picker) {
    var opts = picker.querySelectorAll('[data-pick]');
    var panels = picker.querySelectorAll('[data-panel]');
    var hint = picker.querySelector('[data-picker-hint]');
    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-pick');
        opts.forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
        if (hint) hint.hidden = true;
      });
    });
  });

  /* ---- Prefill the quote form (picker / model CTAs, or ?interest= links) ---- */
  function prefillQuote(use, model) {
    var form = d.getElementById('quote-form');
    if (!form) return;
    var radio = form.querySelector('input[name="contact[use]"][value="' + use + '"]');
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    var field = form.querySelector('input[name="contact[model_interest]"]');
    if (field) field.value = model || '';
  }
  d.querySelectorAll('[data-prefill-use]').forEach(function (link) {
    link.addEventListener('click', function () {
      prefillQuote(link.getAttribute('data-prefill-use'), link.getAttribute('data-prefill-model'));
    });
  });
  /* Same-page ?interest= links: prefill and scroll without a reload */
  d.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="interest="]') : null;
    if (!a || !d.getElementById('quote-form')) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname) return;
    var pick = INTEREST[(url.searchParams.get('interest') || '').toLowerCase()];
    if (!pick) return;
    e.preventDefault();
    prefillQuote(pick[0], pick[1]);
    var target = d.getElementById((url.hash || '#quote').slice(1));
    if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', url.hash || '#quote');
  });

  /* ---- Sticky mobile CTA: hidden while the hero CTA or the quote form is on screen ---- */
  var sticky = d.getElementById('am-sticky');
  if (sticky) {
    var stickyLink = sticky.querySelector('a');
    var setSticky = function (on) {
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (stickyLink) stickyLink.tabIndex = on ? 0 : -1;
    };
    var targets = d.querySelectorAll('[data-sticky-hide]');
    if ('IntersectionObserver' in window && targets.length) {
      var onScreen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) onScreen.add(en.target); else onScreen.delete(en.target); });
        setSticky(onScreen.size === 0);
      });
      targets.forEach(function (t) { io.observe(t); });
    }
  }

  /* ---- Forms: inline validation before Shopify's native /contact submit ---- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function groupOf(form, el) {
    return el.type === 'radio' ? form.querySelectorAll('input[name="' + el.name + '"]') : [el];
  }
  function checkedValue(form, name) {
    var c = form.querySelector('input[name="' + name + '"]:checked');
    return c ? c.value : '';
  }
  function errorFor(form, el) {
    if (el.type === 'radio') return checkedValue(form, el.name) ? '' : (el.getAttribute('data-msg') || 'Please choose an option.');
    var v = (el.value || '').trim();
    var reqIf = el.getAttribute('data-required-if');
    var required = el.required || (reqIf && checkedValue(form, reqIf.split('=')[0]) === reqIf.split('=')[1]);
    if (required && !v) return el.getAttribute('data-msg') || 'This field is required.';
    if (!v) return '';
    if (el.type === 'email' && !EMAIL.test(v)) return 'Please enter a valid email address, like name@example.com.';
    if (el.hasAttribute('data-phone') && v.replace(/\D/g, '').length < 7) return 'Please enter a valid phone number, or leave this blank.';
    if (el.type === 'number') {
      var n = Number(v), min = Number(el.min || 1), max = Number(el.max || 9999);
      if (!Number.isInteger(n) || n < min || n > max) return 'Please enter a whole number between ' + min + ' and ' + max + '.';
    }
    return '';
  }
  function showError(form, el, msg) {
    var ids = (el.getAttribute('aria-describedby') || '').split(' ');
    var box = null;
    for (var i = 0; i < ids.length; i++) { if (/-error$/.test(ids[i])) box = d.getElementById(ids[i]); }
    if (box) box.textContent = msg;
    groupOf(form, el).forEach(function (t) { if (msg) t.setAttribute('aria-invalid', 'true'); else t.removeAttribute('aria-invalid'); });
  }
  function validate(form) {
    var seen = {}, bad = [];
    form.querySelectorAll('[data-validate]').forEach(function (el) {
      if (el.type === 'radio') { if (seen[el.name]) return; seen[el.name] = true; }
      if (el.closest('[hidden]')) { showError(form, el, ''); return; }
      var msg = errorFor(form, el);
      showError(form, el, msg);
      if (msg) bad.push(el);
    });
    return bad;
  }
  /* Lead tracking: once per successful submission (a refresh of the thank-you page does not count again).
     Enhanced conversions: the email captured at submit is handed to the Google tag, which hashes it before sending. */
  function trackLead(form) {
    var key = 'am_lead_' + form.id + '_' + location.search;
    if (readStore(key)) return;
    writeStore(key, 1);
    var ec = readStore('am_ec');
    clearStore('am_ec');
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') {
      if (ec && ec.email) window.gtag('set', 'user_data', { email: ec.email });
      window.gtag('event', 'generate_lead', { form_id: form.id });
      if (window.AM_ADS_SEND_TO) window.gtag('event', 'conversion', { send_to: window.AM_ADS_SEND_TO });
    } else {
      window.dataLayer.push({ event: 'generate_lead', form_id: form.id });
    }
  }

  d.querySelectorAll('form[data-am-form]').forEach(function (form) {
    var qtyWrap = form.querySelector('[data-qty]');
    function syncQty() {
      if (qtyWrap) qtyWrap.hidden = checkedValue(form, 'contact[use]') !== 'Studio';
    }
    syncQty();

    form.addEventListener('change', function (e) {
      if (e.target.name === 'contact[use]') syncQty();
      if (form.hasAttribute('data-tried') && e.target.hasAttribute('data-validate')) showError(form, e.target, errorFor(form, e.target));
    });
    form.addEventListener('focusout', function (e) {
      var el = e.target;
      if (!el.hasAttribute || !el.hasAttribute('data-validate') || el.type === 'radio') return;
      if (form.hasAttribute('data-tried') || (el.value || '').trim()) showError(form, el, errorFor(form, el));
    });

    /* Server-rendered success after Shopify redirects back with ?contact_posted=true */
    var ok = form.querySelector('[data-success]');
    if (ok && !ok.hidden) {
      trackLead(form);
      ok.focus({ preventScroll: true });
      ok.scrollIntoView({ block: 'center' });
    }
  });

  /* Arriving from another page with ?interest= */
  var interest = INTEREST[(new URLSearchParams(location.search).get('interest') || '').toLowerCase()];
  if (interest) prefillQuote(interest[0], interest[1]);

  /* Capture phase on window so this runs before Shopify's own contact-form submit handler
     (which re-submits the form natively for bot protection). Invalid forms never reach it. */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-am-form]')) return;
    form.setAttribute('data-tried', '');
    var summary = form.querySelector('[data-summary]');
    var bad = validate(form);
    if (bad.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (summary) {
        summary.textContent = bad.length === 1 ? 'Please check the highlighted field below.' : 'Please check the ' + bad.length + ' highlighted fields below.';
        summary.hidden = false;
      }
      bad[0].focus();
      return;
    }
    if (form.hasAttribute('data-sending')) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    form.setAttribute('data-sending', '');
    var emailField = form.querySelector('input[type="email"]');
    if (emailField && emailField.value) writeStore('am_ec', { email: emailField.value.trim().toLowerCase() });
    if (summary) summary.hidden = true;
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.textContent = 'Sending…'; btn.setAttribute('aria-busy', 'true'); }
  }, true);

  /* Restore the button if the page is shown again from the back/forward cache */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    d.querySelectorAll('form[data-sending]').forEach(function (form) {
      form.removeAttribute('data-sending');
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.textContent = btn.getAttribute('data-label') || btn.textContent; btn.removeAttribute('aria-busy'); }
    });
  });
  d.querySelectorAll('form[data-am-form] [type="submit"]').forEach(function (b) { b.setAttribute('data-label', b.textContent); });
})();